export default __webpack_public_path__ + "static/media/Believer's Shoes of the Three Clarities.63673236.jpg";